import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Check, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useI18n();
  const [status, setStatus] = useState("checking"); // checking | paid | expired | error
  const [tx, setTx] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setTx(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts >= 6) { setStatus("pending"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts >= 3) setStatus("error");
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [location.search]);

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-6 py-20" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 size={40} className="mx-auto mb-6 animate-spin text-[#86868b]" strokeWidth={1.5} />
            <h1 className="text-2xl font-semibold text-[#1d1d1f] mb-2">
              {lang === "fr" ? "Vérification du paiement…" : "Verifying payment…"}
            </h1>
            <p className="text-[14px] text-[#86868b]">{lang === "fr" ? "Cela prend quelques secondes." : "This takes a few seconds."}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#1d1d1f] text-white flex items-center justify-center mx-auto mb-6">
              <Check size={28} strokeWidth={2} />
            </div>
            <h1 className="text-3xl font-semibold text-[#1d1d1f] mb-2">
              {lang === "fr" ? "Paiement confirmé" : "Payment confirmed"}
            </h1>
            <p className="text-[15px] text-[#86868b] mb-8">
              {lang === "fr"
                ? `Merci. Votre abonnement ${tx?.metadata?.package_name || ""} est actif.`
                : `Thank you. Your ${tx?.metadata?.package_name || ""} subscription is active.`}
            </p>
            <button onClick={() => navigate("/")} className="btn-pill btn-primary text-[14px]" data-testid="back-home-btn">
              {lang === "fr" ? "Retour à l'accueil" : "Back to home"}
            </button>
          </>
        )}
        {(status === "expired" || status === "error" || status === "pending") && (
          <>
            <h1 className="text-2xl font-semibold text-[#1d1d1f] mb-2">
              {status === "expired"
                ? (lang === "fr" ? "Session expirée" : "Session expired")
                : status === "pending"
                ? (lang === "fr" ? "Paiement en cours de traitement" : "Payment processing")
                : (lang === "fr" ? "Erreur" : "Error")}
            </h1>
            <p className="text-[14px] text-[#86868b] mb-8">
              {lang === "fr" ? "Vous pouvez réessayer depuis la page d'accueil." : "You can retry from the home page."}
            </p>
            <button onClick={() => navigate("/")} className="btn-pill btn-secondary text-[14px]">
              {lang === "fr" ? "Retour" : "Back"}
            </button>
          </>
        )}
      </div>
    </main>
  );
}
